<template>
  <table v-if="matches.length" class="table is-striped is-fullwidth">
    <thead>
      <tr>
        <th style="width: 10%">Variant</th>
        <th style="width: 30%;">
          <div class="is-flex is-align-items-center">
            <span class="image is-32x32" v-if="!created">
              <img :src="'KING_WHITE' | chessPieceSvg" alt="" />
            </span>
            <span>{{ created ? "Challenger" : "&nbsp;White Player" }}</span>
          </div>
        </th>
        <th style="width: 30%;">
          <div class="is-flex is-align-items-center">
            <span class="image is-32x32" v-if="!created">
              <img :src="'KING_BLACK' | chessPieceSvg" alt="" />
            </span>
            <span>{{ created ? "" : "&nbsp;Black Player" }}</span>
          </div>
        </th>
        <th style="width: 10%">When</th>
        <th style="width: 10%">Status</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(match, i) in matches" :key="i">
        <td>
          <p>
            <b>{{ match | variantTitle }}</b>
          </p>
          <p>
            <i>{{ match | variantSubtitle }}</i>
          </p>
        </td>
        <td>
          <div class="is-flex is-justify-content-space-between">
            <ProfileCard
              :player="match.player1"
              :rating="
                match.player1 && match.player1.stats
                  ? match.player1.stats.rating
                  : null
              "
              color="white"
              :onlinePlayer="onlinePlayer(match.player1)"
              :challenge="challenge"
            />
            <GameResult :result="match.result" :score="match.player_1_score" />
          </div>
        </td>
        <td>
          <div
            class="is-flex is-justify-content-space-between"
            v-if="match.player2"
          >
            <ProfileCard
              :player="match.player2"
              :rating="
                match.player2 && match.player2.stats
                  ? match.player2.stats.rating
                  : null
              "
              color="white"
              :onlinePlayer="onlinePlayer(match.player2)"
              :challenge="challenge"
            />
            <GameResult :result="match.result" :score="match.player_2_score" />
          </div>
        </td>

        <td>
          <div v-if="match.created || match.createdAt">
            <p>
              {{ (match.created ? match.created : match.createdAt) | asDate }}
            </p>
            <p>
              {{ (match.created ? match.created : match.createdAt) | asTime }}
            </p>
          </div>
        </td>

        <td>
          <router-link
            v-if="match.status !== 'created'"
            :to="getGameUrl(match.match_id)"
            :class="
              match.status === 'live' ? 'has-text-success' : 'has-text-warning'
            "
          >
            <p>
              <b>{{ match | scoreText }}</b>
            </p>
            <p>
              <i>{{ match | resultText }}</i>
            </p>
          </router-link>
          <button
            class="button is-small is-fullwidth is-danger"
            v-if="match.status === 'created' && !currentMatch"
            @click="$emit('onJoinMatch', match)"
          >
            Join Match
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import ProfileCard from "@/components/players/ProfileCard.vue";
import GameResult from "@/components/games/GameResult.vue";
import GameHelper from "@/utils/game-helper";
import gameUrls from "@/mixins/gameUrls";

export default {
  name: "MatchesTable",
  components: {
    ProfileCard,
    GameResult,
  },

  mixins: [gameUrls],

  props: ["currentMatch", "matches", "created", "onlinePlayers", "challenge"],

  filters: {
    variantTitle(match) {
      if (match.variant) return match.variant;
    },

    variantSubtitle(match) {
      if (match.duration) {
        if (match.increment != null) {
          return `${match.duration / 60}+${match.increment}`;
        }
        return `${match.duration / 60}-minute`;
      }
      if (match.scenario_id) {
        return "Level " + Number(match.scenario_id.slice(5));
      }
    },

    scoreText(match) {
      return match.player_1_score != null && match.player_2_score != null
        ? GameHelper.scoreText(match.player_1_score, match.player_2_score)
        : match.status
        ? match.status.toUpperCase()
        : "";
    },

    resultText(match) {
      return match.status === "finished" || match.result ? match.result : "";
    },
  },

  methods: {
    isMine(match) {
      if (!this.currentMatch) return false;
      return this.currentMatch.match_id === match.match_id;
    },

    onlinePlayer(player) {
      if (!player || !player.user_id) return null;
      if (!this.onlinePlayers || !this.onlinePlayers.length) return null;
      return this.onlinePlayers.find((p) => p.user_id === player.user_id);
    },
  },
};
</script>

<style scoped>
th {
  background-color: #5d095d;
  color: white !important;
}

tr {
  background-color: #674ea7;
  color: white;
}

.table.is-striped tbody tr:not(.is-selected):nth-child(even) {
  background-color: #b400b4;
  color: white;
}

p {
  white-space: nowrap;
  overflow: hidden;
}

th,
td {
  vertical-align: middle !important;
}

.profileCard {
  flex-grow: 1;
}
</style>
